import gate from '@/api/axios';

export const contractorAccountFunding = async (id, amount) => gate.post(`/contractors/${id}/accountfunding`, {
  amount,
});

/**
 * Получает список исполнителей
 * @async
 * @function contractorsSearch
 * @param {Object} payload Объект параметров
 * @returns {Promise}
 */
export const contractorsSearch = async (payload) => gate.get('/contractors/search', {
  params: payload,
});

/**
 * Получает список исполнителей для бесконечного скролла
 * @async
 * @function contractorsSimpleSearch
 * @param {Object} payload Объект параметров
 * @returns {Promise}
 */
export const contractorsSimpleSearch = async (payload) => gate.get('/contractors/simpleSearch', {
  params: payload,
});

/**
 * Получает профиль исполнителя
 * @async
 * @function contractorProfile
 * @param {Number|String} id ID исполнителя
 * @returns {Promise}
 */
export const contractorProfile = async (id) => gate.get(`/contractors/${id}`);

/**
 * Получает список заказов исполнителя
 * @param {Number|String} id ID исполнителя
 */
export const contractorOrders = async (id, payload) => gate.get(`/contractors/${id}/searchOrders`, {
  params: payload,
});

/**
 * Получает список транзакций исполнителя
 * @param {Number|String} id ID исполнителя
 */
export const contractorTransactions = async (id, payload) => gate.get(`/contractors/${id}/transactions`, {
  params: payload,
});

/**
 * Блокировка и разблокировка исполнителя
 * @async
 * @function setContractorBlocking
 * @param {Number|String} id ID исполнителя
 * @param {Number|String} reason Причина блокировки
 */
export const setContractorBlocking = async (id, reason) => gate.post(`/contractors/${id}/blocking`, {
  reason,
});

/**
 * Редактирует исполнителя
 * @async
 * @function contractorUpdate
 * @param {Number|String} id ID исполнителя
 * @param {Object} payload
 * @returns {Promise}
 */
export const contractorUpdate = async (id, payload) => gate.patch(`/contractors/${id}`, payload);

/**
 * Удаление исполнителя
 * @async
 * @function contractorDelete
 * @param {Number|String} id ID исполнителя
 * @returns {Promise}
 */
export const contractorDelete = async (id) => gate.delete(`/contractors/${id}`);

/**
 * Получает шаблоны и историю Green API сообщений исполнителя
 * @async
 * @function contractorGreenApiMessages
 * @param {Number|String} id ID исполнителя
 * @returns {Promise}
 */
export const contractorGreenApiMessages = async (id) => gate.get(`/contractors/${id}/green-api/messages`);

/**
 * Отправляет Green API сообщение исполнителю по выбранному шаблону
 * @async
 * @function sendContractorGreenApiMessage
 * @param {Number|String} id ID исполнителя
 * @param {String} templateKey Ключ шаблона сообщения
 * @returns {Promise}
 */
export const sendContractorGreenApiMessage = async (id, templateKey) => gate.post(`/contractors/${id}/green-api/messages`, {
  templateKey,
});


/**
 * Получает историю произвольных PUSH исполнителя
 * @async
 * @function contractorPushMessages
 * @param {Number|String} id ID исполнителя
 * @returns {Promise}
 */
export const contractorPushMessages = async (id) => gate.get(`/contractors/${id}/push/messages`);

/**
 * Отправляет произвольный PUSH исполнителю
 * @async
 * @function sendContractorPushMessage
 * @param {Number|String} id ID исполнителя
 * @param {Object} payload Тело push-уведомления
 * @returns {Promise}
 */
export const sendContractorPushMessage = async (id, payload) => gate.post(`/contractors/${id}/push/messages`, payload);

/**
 * Единый центр коммуникаций исполнителя: доступные каналы + общая история.
 * @param {Number|String} id ID пользователя-исполнителя
 * @returns {Promise}
 */
export const contractorCommunications = async (id) => gate.get(`/contractors/${id}/communications`);

/**
 * Ручная отправка сообщения исполнителю через выбранный канал.
 * @param {Number|String} id ID пользователя-исполнителя
 * @param {Object} payload { channel, ...channelPayload }
 * @returns {Promise}
 */
export const sendContractorCommunication = async (id, payload) => gate.post(`/contractors/${id}/communications`, payload);

export const uploadContractorCommunicationImages = async (id, payload) => gate.post(
  `/contractors/${id}/communications/upload`,
  payload,
);

export const importContractorTalkMe = async (id, dryRun = false) => gate.post(`/contractors/${id}/support/import-talk-me`, { dryRun });

export const contractorSupportUpload = async (id, payload) => gate.post(`/contractors/${id}/support/upload`, payload);
export const contractorSupportRead = async (
  id,
  messageIds = [],
  externalContactIds = [],
) => gate.post(`/contractors/${id}/support/messages/read`, {
  messageIds,
  externalContactIds,
});
